export default "__VITE_ASSET__05dbefee__"